const BV_READY_EVENT = 'bv-ready';
const CATALOG_UPDATE_BV_PIXEL_EVENT = 'CatalogUpdate';
const BV_PIXEL_EVENT_PRODUCT_TYPE = 'Product';

export { BV_READY_EVENT, CATALOG_UPDATE_BV_PIXEL_EVENT, BV_PIXEL_EVENT_PRODUCT_TYPE };
